"use client";

import { AnimateOnScroll, StaggeredList } from "./index";

const logos = [
  { name: "Kiro", icon: "K", gradient: "from-[#FF9500] to-[#FF5E00]" },
  { name: "Claude", icon: "C", gradient: "from-[#D97706] to-[#B45309]" },
  { name: "Cursor", icon: "▲", gradient: "from-black to-[#333]" },
  { name: "Gemini", icon: "G", gradient: "from-[#4285F4] to-[#34A853]" },
  { name: "Copilot", icon: "◇", gradient: "from-black to-[#24292E]" },
];

export function LogoBar() {
  return (
    <section className="py-8 sm:py-10 md:py-12 bg-white border-y border-border">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
        <AnimateOnScroll variant="fade-in">
          <p className="text-center text-[11px] sm:text-xs md:text-[13px] font-medium text-text-muted uppercase tracking-[1px] sm:tracking-[1.5px] mb-4 sm:mb-6 md:mb-8">
            Works with your favorite AI tools
          </p>
        </AnimateOnScroll>
        <StaggeredList
          className="flex justify-center items-center gap-3 sm:gap-4 md:gap-6 lg:gap-10 flex-wrap"
          staggerDelay={60}
          initialDelay={100}
          duration={400}
        >
          {logos.map((logo) => (
            <div
              key={logo.name}
              className="flex items-center gap-1.5 sm:gap-2 md:gap-2.5 px-2.5 py-2 sm:px-4 sm:py-2.5 md:px-5 md:py-3 rounded-lg transition-all hover:bg-bg-alt hover:scale-105"
            >
              <div
                className={`w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 rounded-md sm:rounded-lg flex items-center justify-center text-xs sm:text-sm font-bold text-white bg-gradient-to-br ${logo.gradient}`}
              >
                {logo.icon}
              </div>
              <span className="font-semibold text-xs sm:text-sm text-text">
                {logo.name}
              </span>
            </div>
          ))}
        </StaggeredList>
      </div>
    </section>
  );
}
